<template>
  <v-card class="list-discount-code-record" height="90vh">
    <v-card-title>{{ $t('admin_acc_discount_code.list_record_title') }}</v-card-title>
    <v-card-text>
      <AdminDiscountCodeRecordList full-height
                                   :extra-params="{'discount_code_id': discountCodeId}"></AdminDiscountCodeRecordList>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit')">
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>
<script>
import {onMounted, ref} from "@vue/composition-api";
import AdminDiscountCodeRecordList from "@/components/acc_booking/discount_code/AdminDiscountCodeRecordList.vue";

export default {
  name: 'ListDiscountCodeRecordModal',
  components: {AdminDiscountCodeRecordList},
  props: {
    discountCodeId: [String, Number],
  },
  setup(props, {root, emit}) {
    return {}
  }
}
</script>

<style lang="less">
.list-discount-code-record {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-window__container {
    height: 100%;

    .v-window-item {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 0;
    overflow: auto;
  }
}


</style>
